/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventStateResponseDto
 */
export interface EventStateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof EventStateResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventStateResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof EventStateResponseDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof EventStateResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventStateResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the EventStateResponseDto interface.
 */
export function instanceOfEventStateResponseDto(value: object): value is EventStateResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function EventStateResponseDtoFromJSON(json: any): EventStateResponseDto {
    return EventStateResponseDtoFromJSONTyped(json, false);
}

export function EventStateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventStateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function EventStateResponseDtoToJSON(json: any): EventStateResponseDto {
    return EventStateResponseDtoToJSONTyped(json, false);
}

export function EventStateResponseDtoToJSONTyped(value?: EventStateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

